<app-navigation
  class="pc-sidebar"
  [ngClass]="{
    'navbar-collapsed': navCollapsed,
    'mob-open': navCollapsedMob
  }"
  (NavCollapse)="this.navCollapsed = !this.navCollapsed"
/>
@if (showheader){
<app-nav-bar (NavCollapsedMob)="navMobClick()" (NavCollapse)="this.navCollapsed = !this.navCollapsed" />
}
<div class="pc-container">
  <div class="coded-wrapper">
    <div class="coded-content" [ngStyle]="{
    'position': !showheader ? 'relative' : '',
    'top': !showheader ? '-8vh' : '',
    'padding-top': !showheader ? 'padding-top' :'',
  }">
      <div class="coded-inner-content">
        <app-breadcrumb />
        <div class="main-body">
          <div class="page-wrapper">
            <router-outlet />
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="pc-menu-overlay" (click)="closeMenu()" (keydown)="handleKeyDown($event)" tabindex="0"></div>
</div>
<footer class="pc-footer">
  <div class="footer-wrapper container-fluid">
    <div class="row">
      <div class="col my-1">
        <p class="m-0">
          Copyright &copy;
          <a href="https://appcode.mx" target="_blank">Appcode</a>
        </p>
      </div>
      <div class="col-auto my-1">
        <ul class="list-inline footer-link mb-0">
          <li class="list-inline-item"><a href="https://appcode.mx" target="_blank">Home</a></li>
          <li class="list-inline-item">
            <a href="https://appcode.mx/" target="_blank">Privacy Policy</a>
          </li>
          <li class="list-inline-item"><a href="https://appcode.mx" target="_blank">Contact us</a></li>
        </ul>
      </div>
    </div>
  </div>
</footer>
